import styled from "@emotion/styled";
import { BaseButton } from "@stepfinance/react";
import type { ButtonProps } from "antd";
import type { CSSProperties } from "react";

type MobileWalletConnectButtonProps = ButtonProps & {
  width?: CSSProperties["width"];
};

export const WalletMenuButton: React.FC<MobileWalletConnectButtonProps> = ({ width = "100%", ...buttonProps }) => {
  const widthStyles: CSSProperties = width !== "100%" ? { minWidth: width } : { width };

  return (
    <WalletButton
      style={{
        ...widthStyles,
      }}
      {...buttonProps}
    ></WalletButton>
  );
};

const WalletButton = styled(BaseButton)`
  border-radius: 8px !important;
  font-size: 14px !important;
`;
